// removed by extract-text-webpack-plugin
module.exports = {"list":"list__3m0U4"};


//////////////////
// WEBPACK FOOTER
// ./components/TermsOfUse/style.css
// module id = VYsN
// module chunks = 0